/**
 * 公共工具函数
 * @author: zoiew
 */

/**
 * 处理日期时间
 * @param {*} dateTime 时间戳
 * @param {*} fmt  日期时间格式: YYYY-MM-DD | YYYY-MM-DD hh:mm:ss | YYYY年MM月DD日 hh时mm分ss秒
 */
export default function timeFormat(dateTime = null, fmt = 'YYYY-MM-DD hh:mm:ss') {
  if (!dateTime) {
    dateTime = Number(new Date())
  } else if (typeof dateTime === 'string') {
    fmt = dateTime
    dateTime = Number(new Date())
  }
  if (dateTime.toString().length === 10) dateTime *= 1000
  let date = new Date(Number(dateTime))
  let ret
  let opt = {
    'Y+': date.getFullYear().toString(),
    'M+': (date.getMonth() + 1).toString(),
    'D+': date.getDate().toString(),
    'h+': date.getHours().toString(),
    'm+': date.getMinutes().toString(),
    's+': date.getSeconds().toString()
  }

  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
    }
  }

  return fmt
}

/**
 * @param {string} bundleUrl 链接地址
 */
export function generateUrlPrefix(bundleUrl) {
  let url = weex.config.bundleUrl
  if (url.indexOf('?') > 0) {
    url = url.substring(0, url.indexOf('?'))
  }
  url = url
    .split('/')
    .slice(0, -2)
    .join('/')

  if (url.indexOf('http') !== 0 && url.indexOf('file') !== 0) {
    if (url.indexOf('/') === 0) {
      url = url.substring(url.indexOf('/') + 1)
    }
    url = 'local://' + (url === '' ? '' : '/') + url
  }
  return url
}



// WEBPACK FOOTER //
// ./packages/utils/timeFormat.js